import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import SoftButton from "components/SoftButton";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import Divider from "@mui/material/Divider";
import NetPayBox from "../../NetPayBox";
import logoCT from "assets/images/logo-ct.png";

 function Payslip() {

    const { borderWidth } = borders;
  const { light } = colors;
  const borderBottom = `${borderWidth[1]} solid ${light.main}`;
    
  const earnings = [
    { label: "Basic Salary", amount: 25000 },
    { label: "House Rent Allowance", amount: 10000 },
    { label: "Travel Allowance", amount: 2000 },
    { label: "Medical Allowance", amount: 1500 },
    { label: "Reimbursement", amount: 1000},
    { label: "Incentive", amount: 1200},
    {lable: "Overtime Hours", amount:0},
    { label: "Other Allowance", amount: 0},
  ];

  const deductions = [
    { label: "PF (Employee)", amount: 1800 },
    { label: "ESI", amount: 500 },
    { label: "LWF", amount: 200 },
    { label: "Absences", amount: 1000 },
    { label: "Professional Tax", amount: 3200 },
    { label: "Health Insurance", amount: 100 },
    { label: "Loan Repayment", amount: 2000 },
    { label: "Advance (pre payment)", amount: 1200 },
  ];

  const totalEarnings = earnings.reduce((sum, item) => sum + item.amount, 0);
  const totalDeductions = deductions.reduce((sum, item) => sum + item.amount, 0);
  const netPay = totalEarnings - totalDeductions;

   return (
     <Card sx={{ p: 4, borderRadius: 3, boxShadow: "0 4px 12px rgba(0,0,0,0.08)" }}>
       {/* Header */}
       <SoftBox mb={3} >
          <Grid container justifyContent="space-between">
                  <Grid item xs={12} md={4}>
                    <SoftBox component="img" src={logoCT} width="25%" p={1} mb={1} />
                                 
                    <SoftTypography variant="h6" fontWeight="bold">Company Info</SoftTypography>
           <SoftTypography variant="body2">Quest Connect Pvt. Ltd.</SoftTypography>
           <SoftTypography variant="body2">123 Business Park, Mumbai</SoftTypography>
           <SoftTypography variant="body2">GSTIN: 27AAAPL1234C1ZK</SoftTypography>
                    <SoftBox mt={1} mb={2}>
                      <SoftTypography display="block" variant="body2" color="secondary">
                        tel: +4 (074) 1090873
                      </SoftTypography>
                    </SoftBox>
                  </Grid>
                  <Grid item xs={12} md={7} lg={6}>
                    <SoftBox width="100%" textAlign={{ xs: "left", md: "right" }} mt={6}>
                        <SoftTypography variant="h4" fontWeight="bold" color="info.main" mb={3}>
                         Monthly Payslip – July 2025
                     </SoftTypography>
                      <SoftTypography variant="h6" fontWeight="bold">Employee Info</SoftTypography>
           <SoftTypography variant="body2">Name: John Doe</SoftTypography>
          <SoftTypography variant="body2">Employee ID: EMP-1025</SoftTypography>
           <SoftTypography variant="body2">Designation: Software Engineer</SoftTypography>
           <SoftTypography variant="body2">PAN: ABCDE1234F</SoftTypography>
                    </SoftBox>
                  </Grid>
                </Grid>
       </SoftBox>
       <Divider />
      <Grid container spacing={3} mt={2} mb={2} sx={{ display:"flex", flexDirection: "row"}}>
         <Grid item xs={12}  sm={6}  >
           <SoftTypography variant="body2" fontWeight="bold">Pay Period:</SoftTypography>
           <SoftTypography variant="body2">01-Jul-2025 to 31-Jul-2025</SoftTypography>
         </Grid>
         <Grid item xs={12}  sm={6} sx={{ml:0}}>
      <NetPayBox
  netPay="₹77,000.00"
  paidDays={31}
  paidHours={248}
  lopDays={0}
  lopHours={0}
/>
      </Grid>
      </Grid>
      
       <Divider />

      {/* <Grid container spacing={3} mt={3}>
  <Grid item xs={12} sm={6}>
    <SoftTypography variant="h6" fontWeight="bold" color="success.main" mb={1}>
      Earnings
    </SoftTypography>
    <SoftBox display="flex" justifyContent="space-between" mb={1}>
      <SoftTypography variant="button" fontWeight="bold">Component</SoftTypography>
      <SoftTypography variant="button" fontWeight="bold">This Month</SoftTypography>
      <SoftTypography variant="button" fontWeight="bold">Year to Date</SoftTypography>
    </SoftBox>
    {earnings.map((item, index) => (
      <SoftBox key={index} display="flex" justifyContent="space-between" mb={1}>
        <SoftTypography variant="body2">{item.label || item.lable}</SoftTypography>
        <SoftTypography variant="body2">₹ {item.amount.toLocaleString()}</SoftTypography>
        <SoftTypography variant="body2">₹ {(item.amount * 4).toLocaleString()}</SoftTypography>
      </SoftBox>
    ))}
    <Divider />
    <SoftBox display="flex" justifyContent="space-between" mt={1}>
      <SoftTypography fontWeight="bold">Total Earnings</SoftTypography>
      <SoftTypography fontWeight="bold">₹ {totalEarnings.toLocaleString()}</SoftTypography>
      <SoftTypography fontWeight="bold">₹ {(totalEarnings * 4).toLocaleString()}</SoftTypography>
    </SoftBox>
  </Grid>

  <Grid item xs={12} sm={6}>
    <SoftTypography variant="h6" fontWeight="bold" color="error.main" mb={1}>
      Deductions
    </SoftTypography>
    <SoftBox display="flex" justifyContent="space-between" mb={1}>
      <SoftTypography variant="button" fontWeight="bold">Component</SoftTypography>
      <SoftTypography variant="button" fontWeight="bold">This Month</SoftTypography>
      <SoftTypography variant="button" fontWeight="bold">Year to Date</SoftTypography>
    </SoftBox>
    {deductions.map((item, index) => (
      <SoftBox key={index} display="flex" justifyContent="space-between" mb={1}>
        <SoftTypography variant="body2">{item.label}</SoftTypography>
        <SoftTypography variant="body2">₹ {item.amount.toLocaleString()}</SoftTypography>
        <SoftTypography variant="body2">₹ {(item.amount * 4).toLocaleString()}</SoftTypography>
      </SoftBox>
    ))}
    <Divider />
    <SoftBox display="flex" justifyContent="space-between" mt={1}>
      <SoftTypography fontWeight="bold">Total Deductions</SoftTypography>
      <SoftTypography fontWeight="bold">₹ {totalDeductions.toLocaleString()}</SoftTypography>
      <SoftTypography fontWeight="bold">₹ {(totalDeductions * 4).toLocaleString()}</SoftTypography>
    </SoftBox>
  </Grid>
</Grid> */}



      <Grid container spacing={3} mt={3}>
  {/* Earnings */}
  <Grid item xs={12} sm={6}>
    <SoftTypography variant="h6" fontWeight="bold" color="success.main" mb={1}>
      Earnings
    </SoftTypography>
    <SoftBox
      display="flex"
      justifyContent="space-between"
      fontWeight="bold"
      borderBottom="1px solid #e0e0e0"
      pb={1}
    >
      <SoftTypography variant="button" sx={{ minWidth: "40%" }}>Component</SoftTypography>
      <SoftTypography variant="button" sx={{ minWidth: "30%", textAlign: "right" }}>This Month</SoftTypography>
      <SoftTypography variant="button" sx={{ minWidth: "30%", textAlign: "right" }}>YTD</SoftTypography>
    </SoftBox>

    {earnings.map((item, index) => (
      <SoftBox
        key={index}
        display="flex"
        justifyContent="space-between"
        py={1}
        borderBottom="1px solid #f0f0f0"
      >
        <SoftTypography variant="body2" sx={{ minWidth: "40%" }}>
          {item.label || item.lable}
        </SoftTypography>
        <SoftTypography variant="body2" sx={{ minWidth: "30%", textAlign: "right" }}>
          ₹ {item.amount.toLocaleString()}
        </SoftTypography>
        <SoftTypography variant="body2" sx={{ minWidth: "30%", textAlign: "right" }}>
          ₹ {(item.amount * 4).toLocaleString()}
        </SoftTypography>
      </SoftBox>
    ))}

    <SoftBox display="flex" justifyContent="space-between" mt={2}>
      <SoftTypography fontWeight="bold" sx={{ minWidth: "40%" }}>Total Earnings</SoftTypography>
      <SoftTypography fontWeight="bold" sx={{ minWidth: "30%", textAlign: "right" }}>
        ₹ {totalEarnings.toLocaleString()}
      </SoftTypography>
      <SoftTypography fontWeight="bold" sx={{ minWidth: "30%", textAlign: "right" }}>
        ₹ {(totalEarnings * 4).toLocaleString()}
      </SoftTypography>
    </SoftBox>
  </Grid>

  {/* Deductions */}
  <Grid item xs={12} sm={6}>
    <SoftTypography variant="h6" fontWeight="bold" color="error.main" mb={1}>
      Deductions
    </SoftTypography>
    <SoftBox
      display="flex"
      justifyContent="space-between"
      fontWeight="bold"
      borderBottom="1px solid #e0e0e0"
      pb={1}
    >
      <SoftTypography variant="button" sx={{ minWidth: "40%" }}>Component</SoftTypography>
      <SoftTypography variant="button" sx={{ minWidth: "30%", textAlign: "right" }}>This Month</SoftTypography>
      <SoftTypography variant="button" sx={{ minWidth: "30%", textAlign: "right" }}>YTD</SoftTypography>
    </SoftBox>

    {deductions.map((item, index) => (
      <SoftBox
        key={index}
        display="flex"
        justifyContent="space-between"
        py={1}
        borderBottom="1px solid #f0f0f0"
      >
        <SoftTypography variant="body2" sx={{ minWidth: "40%" }}>
          {item.label}
        </SoftTypography>
        <SoftTypography variant="body2" sx={{ minWidth: "30%", textAlign: "right" }}>
          ₹ {item.amount.toLocaleString()}
        </SoftTypography>
        <SoftTypography variant="body2" sx={{ minWidth: "30%", textAlign: "right" }}>
          ₹ {(item.amount * 4).toLocaleString()}
        </SoftTypography>
      </SoftBox>
    ))}

    <SoftBox display="flex" justifyContent="space-between" mt={2}>
      <SoftTypography fontWeight="bold" sx={{ minWidth: "40%" }}>Total Deductions</SoftTypography>
      <SoftTypography fontWeight="bold" sx={{ minWidth: "30%", textAlign: "right" }}>
        ₹ {totalDeductions.toLocaleString()}
      </SoftTypography>
      <SoftTypography fontWeight="bold" sx={{ minWidth: "30%", textAlign: "right" }}>
        ₹ {(totalDeductions * 4).toLocaleString()}
      </SoftTypography>
    </SoftBox>
  </Grid>
</Grid>




       {/* <Grid container spacing={3} mt={3}>
         <Grid item xs={12} sm={6}>
           <SoftTypography variant="h6" fontWeight="bold" color="success.main" mb={1}>
             Earnings
           </SoftTypography>
           {earnings.map((item, index) => (
            <SoftBox key={index} display="flex" justifyContent="space-between" mb={1}>
              <SoftTypography variant="body2">{item.label}</SoftTypography>
              <SoftTypography variant="body2">₹ {item.amount.toLocaleString()}</SoftTypography>
            </SoftBox>
          ))}
          <Divider />
          <SoftBox display="flex" justifyContent="space-between" mt={1}>
            <SoftTypography fontWeight="bold">Total Earnings</SoftTypography>
            <SoftTypography fontWeight="bold">₹ {totalEarnings.toLocaleString()}</SoftTypography>
          </SoftBox>
        </Grid>

        <Grid item xs={12} sm={6}>
          <SoftTypography variant="h6" fontWeight="bold" color="error.main" mb={1}>
            Deductions
          </SoftTypography>
          {deductions.map((item, index) => (
            <SoftBox key={index} display="flex" justifyContent="space-between" mb={1}>
              <SoftTypography variant="body2">{item.label}</SoftTypography>
              <SoftTypography variant="body2">₹ {item.amount.toLocaleString()}</SoftTypography>
            </SoftBox>
          ))}
          <Divider />
          <SoftBox display="flex" justifyContent="space-between" mt={1}>
            <SoftTypography fontWeight="bold">Total Deductions</SoftTypography>
            <SoftTypography fontWeight="bold">₹ {totalDeductions.toLocaleString()}</SoftTypography>
          </SoftBox>
        </Grid>
      </Grid> */}



    {/* <Divider sx={{ my: 3 }} /> */}
    


{/* Paid Days/Hours and LOP Section */}
{/* <SoftBox>
  <SoftTypography variant="h6" fontWeight="bold" mb={2}>
    Attendance Summary
  </SoftTypography>
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6}>
      <SoftBox
        display="flex"
        justifyContent="space-between"
        border="1px solid #e0e0e0"
        borderRadius="8px"
        p={1}
        mb={1}
      >
        <SoftTypography fontWeight="medium" variant="body2">Paid Days</SoftTypography>
        <SoftTypography fontWeight="medium" variant="body2" color="success">
          26 Days
        </SoftTypography>
      </SoftBox>
      <SoftBox
        display="flex"
        justifyContent="space-between"
        border="1px solid #e0e0e0"
        borderRadius="8px"
        p={1}
      >
        <SoftTypography fontWeight="medium" variant="body2">Paid Hours</SoftTypography>
        <SoftTypography fontWeight="medium" variant="body2" color="success">
          208 Hrs
        </SoftTypography>
      </SoftBox>
    </Grid>

    <Grid item xs={12} sm={6}>
      <SoftBox
        display="flex"
        justifyContent="space-between"
        border="1px solid #e0e0e0"
        borderRadius="8px"
        p={1}
        mb={1}
      >
        <SoftTypography fontWeight="medium" variant="body2">LOP Days</SoftTypography>
        <SoftTypography fontWeight="medium" variant="body2" color="error">
          2 Days
        </SoftTypography>
      </SoftBox>
      <SoftBox
        display="flex"
        justifyContent="space-between"
        border="1px solid #e0e0e0"
        borderRadius="8px"
        p={1}
      >
        <SoftTypography fontWeight="medium" variant="body2">LOP Hours</SoftTypography>
        <SoftTypography fontWeight="medium" variant="body2" color="error">
          16 Hrs
        </SoftTypography>
      </SoftBox>
    </Grid>
  </Grid>
</SoftBox> */}

<Divider sx={{ my: 3 }} />



      {/* <Divider sx={{ my: 3 }} /> */}

      <SoftBox display="flex" justifyContent="space-between" alignItems="center">
        <SoftTypography variant="h5" fontWeight="bold">Net Pay</SoftTypography>
        <SoftTypography variant="h5" fontWeight="bold" color="info.main">
          ₹ {netPay.toLocaleString()}
        </SoftTypography>
      </SoftBox>
      <Divider sx={{ my: 3 }} />
      <SoftBox p={3} mt={7}>
                <Grid container>
                  <Grid item xs={12} lg={5}>
                    <SoftTypography variant="h5" fontWeight="medium">
                      Thank you!
                    </SoftTypography>
                    <SoftBox mt={1} mb={2} lineHeight={0}>
                      <SoftTypography variant="button" fontWeight="regular" color="secondary">
                        If you encounter any issues related to the Payslip you can contact us at:
                      </SoftTypography>
                    </SoftBox>
                    <SoftTypography
                      component="span"
                      variant="h6"
                      fontWeight="medium"
                      color="secondary"
                    >
                      email:{" "}
                      <SoftTypography component="span" variant="h6" fontWeight="medium">
                        support@creative-tim.com
                      </SoftTypography>
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={12} lg={7}>
                    <SoftBox
                      width="100%"
                      height={{ xs: "auto", md: "100%" }}
                      display="flex"
                      justifyContent={{ xs: "flex-start", md: "flex-end" }}
                      alignItems="flex-end"
                      mt={{ xs: 2, md: 0 }}
                    >
                      <SoftButton
                        variant="gradient"
                        color="info"
                        onClick={() => window.print(this)}
                      >
                        print
                      </SoftButton>
                    </SoftBox>
                  </Grid>
                </Grid>
              </SoftBox>
    </Card>
  );
 }

 export default Payslip;
